// Constants
const BRAND_NAME = "Clientix";

interface AppLogoProps {
  showText?: boolean;
}

/**
 * AppLogo Component
 * Renders the application logo with optional branded text
 */
export const AppLogo = ({ showText = true }: AppLogoProps) => {
  return (
    <div
      className="flex items-center gap-2"
      role="banner"
      aria-label="Application logo"
    >
      <div className="dark:bg-white dark:rounded-md dark:p-1">
        <img 
          src="/logo.png" 
          alt="Clientix Logo" 
          className={showText ? "h-8 w-auto dark:h-6" : "h-12 w-auto dark:h-10"}
          aria-hidden="true" 
        />
      </div>
      {showText && (
        <span
          className="text-xl font-bold text-foreground"
          aria-label={BRAND_NAME}
        >
          {BRAND_NAME}
        </span>
      )}
    </div>
  );
};
